<script>
import Popover from './Popover'

export { default as ClosePopover } from './ClosePopover'

/**
 * バルーンの表示を管理するコンポーネント
 *
 * [v-tooltip](https://github.com/Akryum/v-tooltip) を使用しています。
 */
export default {
  name: 'Popover',
  extends: Popover,
}
</script>

<style lang="postcss" scoped>
.trigger {
  outline: none;

  @media screen and (max-width: 767px) {
    display: block !important;
  }
}

.popover {
  outline: none;
  z-index: 1;

  & .popover-inner {
    background: #fff;
    border: 1px solid var(--border-color);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
    box-sizing: border-box;
    overflow: hidden;
  }

  & .popover-arrow {
    border-color: var(--border-color);
    border-style: solid;
    height: 0;
    margin: 5px;
    position: absolute;
    width: 0;
    z-index: 1;

    &::after {
      border-color: var(--white);
      border-style: solid;
      content: '';
      height: 0;
      position: absolute;
      width: 0;
    }
  }

  &[x-placement^='top'] {
    margin-bottom: 8px;

    & .tooltip-arrow {
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-right-color: transparent;
      border-width: 16px 16px 0;
      bottom: -16px;
      left: calc(50% - 16px);
      margin-bottom: 0;
      margin-top: 0;

      &::after {
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        border-width: 16px 16px 0;
        bottom: 1px;
        left: -16px;
        margin-bottom: 0;
        margin-top: 0;
      }
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 8px;

    & .tooltip-arrow {
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      border-width: 0 16px 16px;
      left: calc(50% - 16px);
      margin-bottom: 0;
      margin-top: 0;
      top: -16px;

      &::after {
        border-left-color: transparent;
        border-right-color: transparent;
        border-top-color: transparent;
        border-width: 0 16px 16px;
        left: -16px;
        margin-bottom: 0;
        margin-top: 0;
        top: 1px;
      }
    }
  }

  &[x-placement^='right'] {
    margin-left: 8px;

    & .tooltip-arrow {
      border-bottom-color: transparent;
      border-left-color: transparent;
      border-top-color: transparent;
      border-width: 16px 16px 16px 0;
      left: -16px;
      margin-left: 0;
      margin-right: 0;
      top: calc(50% - 16px);

      &::after {
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-top-color: transparent;
        border-width: 16px 16px 16px 0;
        left: 1px;
        margin-left: 0;
        margin-right: 0;
        top: -16px;
      }
    }
  }

  &[x-placement^='left'] {
    margin-right: 8px;

    & .tooltip-arrow {
      border-bottom-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      border-width: 16px 0 16px 16px;
      margin-left: 0;
      margin-right: 0;
      right: -16px;
      top: calc(50% - 16px);

      &::after {
        border-bottom-color: transparent;
        border-right-color: transparent;
        border-top-color: transparent;
        border-width: 16px 0 16px 16px;
        margin-left: 0;
        margin-right: 0;
        right: 1;
        top: -16px;
      }
    }
  }

  &[aria-hidden='true'] {
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
    visibility: hidden;
  }

  &[aria-hidden='false'] {
    opacity: 1;
    transition: opacity 0.15s;
    visibility: visible;
  }
}
</style>
